import { withRouter } from 'react-router-dom';
export default withRouter;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_umi@2.6.8@umi/lib/withRouter.js
// module id = 1187
// module chunks = 0